import React, { useCallback, useEffect, useState } from "react";
import { Col, Button } from "reactstrap";
import Dropzone from "react-dropzone";
import { withNamespaces } from "react-i18next";
import AttachmentCard from "./components/AttachmentCard";
import axios from "axios";
import { API_BASE_URL } from "src/modules/3rd-party-management/constants/ApiRoutes";
import { toast } from "react-toastify";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import UploadingFilesModal from "./components/UploadingFilesModal";

const MessageInput = ({
  
  t,
  sendButtonDisable,
  handlerSendMessage,
  uploadUrl,
  userToken,
  deleteFileUrl,
  dragFiles,
  downloadUrl,
  communicationDisabled,
  mentionSettings
}) => {
  const [isDisable, setIsDisable] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [showUploadingModal, setShowUploadingModal] = useState(false);
  const [confirmHideUploadingModal, setConfirmHideUploadingModal] = useState(false);

  const handlerMessage = async () => {
    // Perform your actual action with the input value
    const commentContent = convertToRaw(editorState.getCurrentContent());
    const plainText = EditorState.createWithContent(convertFromRaw(commentContent)).getCurrentContent().getPlainText();
    const mentions = getMentionsId(commentContent);

    const messageSent = await handlerSendMessage(plainText, uploadedFiles, mentions);
    if (messageSent) {
      setEditorState(EditorState.createEmpty());
      setUploadedFiles([]);
    }
    // Scroll the chat conversation down after a short delay to allow for DOM update
  };

  useEffect(() => {
    setIsDisable(sendButtonDisable);
  }, [sendButtonDisable]);

  useEffect(() => {
    if (dragFiles && dragFiles?.length > 0) {
      handleAcceptedFiles(dragFiles);
    }
  }, [dragFiles]);

  useEffect(() => {
    // Check if there are any files in progress
    const isInProgress = uploadedFiles.some(
      (file) => file.status === "uploading" || file.status === "deleting"
    );

    // If there are files in progress or if sendButtonDisable is true, disable the button
    setIsDisable(isInProgress || sendButtonDisable);
  }, [uploadedFiles, sendButtonDisable]);

  useEffect(() => {
    if (uploadedFiles.length > 0 && !confirmHideUploadingModal) {
        setShowUploadingModal(true)
    }
    else {
        setShowUploadingModal(false);
    }
  }, [ uploadedFiles, confirmHideUploadingModal ])

  const onUploadProgress = (e, file, setUploadedFiles) => {
    const { total, loaded, lengthComputable } = e;

    if (lengthComputable) {
      const uploadedPercent = (loaded / total) * 100;

      setUploadedFiles((uploadedFiles) => {
        const index = uploadedFiles.findIndex(
          (f) => f.preview === file.preview
        );

        if (index > -1) {
          uploadedFiles[index].uploadedPercent = uploadedPercent;

          return [...uploadedFiles];
        }

        return [...uploadedFiles];
      });
    }
  };

  const handleAcceptedFiles = (files, id) => {
    const headers = {
      headers: {},
      onUploadProgress: null,
    };

    if (userToken) {
      headers.headers.Authorization = `Bearer ${userToken}`;
    }

    files.map((file) => {
      const formData = new FormData();

      formData.append("file", file);

      file = {
        ...file,
        id: null,
        status: "uploading",
        name: file.name,
        type: file.type,
        questionId: id,
        uploadedPercent: 0,
        preview: URL.createObjectURL(file),
        formattedSize: file.size,
      };

      setUploadedFiles((uploadedFiles) => {
        return [...uploadedFiles, { ...file }];
      });

      axios
        .post(`${API_BASE_URL}${uploadUrl}`, formData, {
          ...headers,
          onUploadProgress: (e) => {
            onUploadProgress(e, file, setUploadedFiles);
          },
        })
        .then((response) => {
          setUploadedFiles((uploadedFiles) => {
            const index = uploadedFiles.findIndex(
              (f) => f.preview === file.preview
            );

            if (index > -1) {
              if (response.status === 200) {
                const fileData = response.data.data;

                uploadedFiles[index].status = "upload_succeed";

                uploadedFiles[index].id = fileData.id;
              } else {
                uploadedFiles[index].status = "upload_failed";
              }

              return [...uploadedFiles];
            }

            return [...uploadedFiles];
          });
        })
        .catch((error) => {
          setUploadedFiles((uploadedFiles) => {
            const index = uploadedFiles.findIndex(
              (f) => f.preview === file.preview
            );

            if (index > -1) {
              uploadedFiles[index].status = "upload_failed";

              return [...uploadedFiles];
            }

            return [...uploadedFiles];
          });

          toast(t(error.response.data.message), {
            type: "error",
          });
        });
    });
  };

    const handleClickDeleteFiles = useCallback((file) => {
        const url = `${API_BASE_URL}${deleteFileUrl}${file.id}/delete`;

        const headers = {
            headers: {},
        };

        if (userToken) {
            headers.headers.Authorization = `Bearer ${userToken}`;
        }

        const deletedFile = {
            file: file.name,
            report_case_id: file.id,
        };

        setUploadedFiles((uploadedFiles) => {
            const index = uploadedFiles.findIndex((f) => f.id === file.id);

            if (index > -1) {
                uploadedFiles[index].status = "deleting";

                return [...uploadedFiles];
            }

            return [...uploadedFiles];
        });

        axios
            .post(url, deletedFile, headers)
            .then(() => {
                setUploadedFiles((currentState) => {
                    return [
                        ...currentState
                    ].filter((f) => f.id !== file.id)
                });
            })
            .catch((error) => {
                setUploadedFiles((currentState) => {
                    return [
                        ...currentState
                    ].filter((f) => f.id !== file.id)
                });
                
                toast(t(error?.response?.data.error), {
                    type: "error",
                });
            });
    }, []);

  const getMentionsId = (commentContent) => {
    let myMention = commentContent.entityMap;

    let element = [];

    for (let i = 0; i < Object.keys(myMention).length; i++) {
      element.push(myMention[i].data.url);
    }
    return element;
  }

  return (
    <React.Fragment>
      <div className="p-3 border-top w-100">
        <div className="d-flex gap-4 align-items-start">
          <Dropzone
            onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}
          >
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()} className="dropzone tpdd">
                <input {...getInputProps()} disabled={communicationDisabled.value}/>
                <Button
                    disabled={communicationDisabled.value}
                  style={{
                    background: "#fff",
                    border: "none",
                    fontSize: "20px",
                    paddingRight: 0,
                    fontWeight: '400'
                  }}
                  color="#505D69"
                >
                  <i className="ri-attachment-line"></i>
                </Button>
              </div>
            )}
          </Dropzone>

          <div className="w-100 mt-1">
            <div className="message-input-container mb-1">
              <Editor
                readOnly={communicationDisabled.value}
                handleReturn={() => {
                  return true;
                }}
                placeholder={`${t("Enter Message")}...`}
                wrapperClassName="editor-default message-input"
                editorState={editorState}
                onEditorStateChange={ (state) => setEditorState(state) }
                toolbarHidden={true}
                {
                  ...{
                    mention : (!!mentionSettings?.enable && Array.isArray(mentionSettings?.suggestionList)) ? {
                      separator   : ' ',
                      trigger     : '@',
                      suggestions : mentionSettings.suggestionList
                    } : undefined
                  }
                }
              />
              {uploadedFiles.length > 0 ? (
                <Col xs={12} className="p-3">
                  <div className="d-flex flex-wrap gap-2">
                    {uploadedFiles.map((file, index) => (
                      <AttachmentCard
                        key={index}
                        attachment={file}
                        handleClickDeleteFile={handleClickDeleteFiles}
                        downloadUrl={downloadUrl}
                        t={t}
                      />
                    ))}
                  </div>
                </Col>
              ) : null}
            </div>
            {communicationDisabled.value && (
                <span className="text-danger">
                    {t(communicationDisabled.reason)}
                </span>
            )}
          </div>

          <Button
            color="primary"
            type="submit"
            className="mt-1 chat-send w-md waves-effect waves-light"
            onClick={handlerMessage}
            disabled={isDisable || communicationDisabled.value}
          >
            <span className="d-none d-sm-inline-block me-2">{t("Send")}</span>
            <i className="mdi mdi-send"></i>
          </Button>
        </div>
      </div>

        <UploadingFilesModal
            isOpen={showUploadingModal}
            toggle={() => {
                setConfirmHideUploadingModal(true)
                setShowUploadingModal(false)
            }}
            uploadingFiles={uploadedFiles}
            downloadUrl={downloadUrl}
        />
    </React.Fragment>
  );
};

export default withNamespaces()(MessageInput);
